import React from 'react'

const FeedBackBot = () => {
  return (
    <div className='flex md:justify-center justify-start items-center mt-3'>
        <p className='w-1/2 leading-4'>Get unlimited doubt solving and live interview feedback anytime with Ninja bot.</p>
        <div className='w-[153px] h-[233px]'>
            <img src='https://assets.learntube.ai/files/AI_Syllabus_generator/ezgif.com-optimize.gif?updatedAt=1686638228154' className='w-full h-full object-fill rounded-xl'/>
        </div>
    </div>
  )
}

export default FeedBackBot